IntroResults = new (function () {
  this.setSelects = () => {
    let wrapper = $(".manage-intro-results");

    $("#intro_results_year_group", wrapper).select2({
      placeholder: "- Filter by current year group -",
      minimumResultsForSearch: Infinity,
    });

    $("#intro_results_school_id", wrapper).select2({
      placeholder: "- Filter by school -",
    });

    $("#intro_result_student_select", wrapper).select2({
      placeholder: "- Filter by student name -",
      ajax: {
        dataType: "json",
        url: "/student_entities/autocomplete",
        delay: 250,
        data: (params) => ({ ...params, current_year: wrapper[0]?.querySelector("form")["current_year"]?.value }),
      },
    });

    $("#intro_result_year_of_exam", wrapper).select2({
      placeholder: "- Select -",
      minimumResultsForSearch: Infinity,
    });
  };

  function refreshDataTable(stickyTable) {
    let introResultsTableWrapper = $(".table-body-wrapper");
    if (introResultsTableWrapper && introResultsTableWrapper.length) {
      introResultsTableWrapper.floatingScroll();
      stickyTable.bind();
    }
  }

  this.bindEvents = () => {
    let manageIntroResultsPage = $(".manage-intro-results");
    if (!manageIntroResultsPage || !manageIntroResultsPage.length) return;

    const stickyTable = new Shared.StickyTable();

    $(document).ready(() => refreshDataTable(stickyTable));
    $(document).ajaxComplete(() => refreshDataTable(stickyTable));
  };
})();
